module.exports = __webpack_public_path__ + "img/remove.c5da545b.svg";